import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getUserMembership, isUserUnderTrial } from '../../utilities/user';
import Membership from './Membership';
import text from '../../text';
import FreeUserMembership from './FreeUserMembership';
import Loading from '../../components/loading/Loading';
var MembershipTab = function() {
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var render = function(user) {
        if (getUserMembership(user) && !isUserUnderTrial(user)) {
            return /*#__PURE__*/ React.createElement(Membership, null);
        } else if (!getUserMembership(user) && !isEmpty(user) || isUserUnderTrial(user)) {
            return /*#__PURE__*/ React.createElement(FreeUserMembership, null);
        } else {
            return /*#__PURE__*/ React.createElement(Loading, null);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", {
        className: "mb-3 green-1"
    }, text('membership')), render(currentUser));
};
export default MembershipTab;
